import { useEffect, useState } from "react";
import FinancePicker from "./FinancePicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faFileInvoice, faHandshake, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import BigErrorPopup from "../../../../../../../../layout/Popups/BigErrorPopup";
import FinanceCard from "./FinanceCard";
import listHandler from "@serie3/common/Domain/listHandler";
import { btn, btnHoverStyle } from "../../../../../../../../layout/Buttons/buttonStyles";

const typeConfig = {
  Rechnung: { label: "Bills", icon: faFileInvoice },
  Auftrag: { label: "Orders", icon: faShoppingCart },
  Angebot: { label: "Offers", icon: faHandshake },
};

const ProjectFinanceWrapper = ({ formik, finance = [], direction }) => {
  const [show, setShow] = useState(false);
  const [showError, setShowError] = useState(false);
  const [bills, setBills] = useState([]);
  const [offers, setOffers] = useState([]);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    finance.map((subarray) => {
      switch (subarray.typ) {
        case "Angebot": setOffers(subarray); break;
        case "Rechnung": setBills(subarray); break;
        case "Auftrag": setOrders(subarray); break;
      }
    });
  }, [finance]);

  const unlinkElement = (item) => {
    formik.values.finance = listHandler.deleteWithoutCall(item, formik.values.finance);
    formik.handleSubmit();
  };

  const ShowRow = ({ financeItems }) => {
    if (!financeItems || !financeItems.data || financeItems.data.length === 0) return null;
    const cfg = typeConfig[financeItems.typ] || {};

    return (
      <div style={{ marginBottom: "24px" }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "12px",
        }}>
          <div style={{
            width: "28px",
            height: "28px",
            borderRadius: "8px",
            background: "#e8f0fe",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#1a73e8",
            fontSize: "0.8rem",
            flexShrink: 0,
          }}>
            <FontAwesomeIcon icon={cfg.icon || faFileInvoice} />
          </div>
          <span style={{ fontWeight: 700, fontSize: "0.95rem", color: "#212121" }}>
            {cfg.label || financeItems.typ}
          </span>
          <span style={{
            background: "#f5f5f5",
            color: "#616161",
            borderRadius: "20px",
            padding: "2px 8px",
            fontSize: "0.75rem",
            fontWeight: 600,
          }}>
            {financeItems.data.length}
          </span>
          <div style={{ flex: 1, height: "1px", background: "#f0f0f0", marginLeft: "4px" }} />
        </div>
        <div className="row">
          {financeItems.data.map((item) => (
            <FinanceCard
              key={item.id}
              bill={item}
              unlinkFunction={() => unlinkElement(item)}
            />
          ))}
        </div>
      </div>
    );
  };

  return (
    <>
      <style>{btnHoverStyle}</style>
      <BigErrorPopup showError={showError} setShowError={setShowError} />
      <FinancePicker show={show} setShow={setShow} formik={formik} direction={direction} />

      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
        <button
          className="btn-modern"
          style={{ ...btn.base, ...btn.success }}
          onClick={() => setShow(true)}
        >
          <FontAwesomeIcon icon={faAdd} /> Add
        </button>
      </div>

      <ShowRow financeItems={bills} />
      <ShowRow financeItems={orders} />
      <ShowRow financeItems={offers} />
    </>
  );
};

export default ProjectFinanceWrapper;
